module.exports = __webpack_public_path__ + "img/BCPicon.6c6c837e.6c6c837e.png";